var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "right-body",
      attrs: { id: "home" },
      on: {
        contextmenu: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.clouds.length,
              expression: "clouds.length"
            }
          ],
          staticStyle: { width: "100%", height: "100%" }
        },
        [
          _c("div", { staticClass: "right-middle home-middle" }, [
            _c(
              "button",
              {
                staticClass: "home-button",
                on: {
                  click: function($event) {
                    return _vm.toAddCloudPage()
                  }
                }
              },
              [
                _c("div", { staticClass: "icon addCloudIcon" }),
                _vm._v(_vm._s(_vm.$t("language.common.addCloud")))
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "home-button",
                on: {
                  click: function($event) {
                    return _vm.toAddEmailPage()
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "icon addEmailIcon",
                  staticStyle: { "margin-top": "6px" }
                }),
                _vm._v(_vm._s(_vm.$t("language.common.addEmail")))
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right-cont-body" }, [
            _c(
              "div",
              { staticClass: "home-box", attrs: { id: "homeBox" } },
              [
                _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "home-clouds-up",
                      style: {
                        height: Math.ceil(_vm.drivesUp.length / 4) * 81 + "px"
                      }
                    },
                    _vm._l(_vm.drivesUp, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "cloud-box",
                          class:
                            _vm.indexCurrent == index ? "cloud-click " : "",
                          attrs: { title: _vm.showInfo(item) },
                          on: {
                            mouseenter: function($event) {
                              _vm.hoverCurrent = index
                            },
                            mouseleave: function($event) {
                              _vm.hoverCurrent = -1
                            },
                            click: function($event) {
                              ;(_vm.indexCurrent = index),
                                (_vm.downIndexCurrent = -1)
                            },
                            dblclick: function($event) {
                              return _vm.toCloudCatalog(item)
                            },
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.editDriveMenushow(
                                $event,
                                index,
                                item,
                                "up"
                              )
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "cloud-box-left" }, [
                            _c("div", {
                              staticClass: "icon  home-cloud-position",
                              class: item.appName + "-small"
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cloud-box-right" }, [
                            _c("div", { staticClass: "right-info" }, [
                              _c("div", { staticClass: "name-outer" }, [
                                _c(
                                  "div",
                                  {
                                    ref: "driveName",
                                    refInFor: true,
                                    staticClass: "drive-bold-name"
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.name))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "inputName",
                                    refInFor: true,
                                    staticClass: "home-outclass"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.inputValue,
                                          expression: "item.inputValue"
                                        }
                                      ],
                                      staticClass: "home-task-edit",
                                      domProps: { value: item.inputValue },
                                      on: {
                                        focus: function($event) {
                                          _vm.isflage = true
                                        },
                                        blur: function($event) {
                                          return _vm.submitDriveName(
                                            item,
                                            index
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "inputValue",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "home-edit-icon" },
                                      [
                                        _c("i", {
                                          staticClass: "icon-util name-sure",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.submitDriveName(
                                                item,
                                                index
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "icon-util name-cancel ",
                                          on: {
                                            mousedown: function($event) {
                                              $event.stopPropagation()
                                              return _vm.cancelEditDriveName(
                                                item,
                                                index
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "drive-progrss-box" }, [
                                _c("div", {
                                  class:
                                    (item.driveInfo.usedSpace /
                                      item.driveInfo.totalSpace) *
                                      100 >
                                    90
                                      ? "drive-red-progress"
                                      : "drive-progrss",
                                  style: {
                                    width:
                                      (item.driveInfo.usedSpace /
                                        _vm.analyzeTotalSpace(item)) *
                                        100 +
                                      "%"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "drive-capacity" }, [
                                item.isRotate ||
                                (!item.haveLoad &&
                                  !item.driveInfo.totalSpace &&
                                  !item.isRotate)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.load"))
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !item.isRotate && item.driveInfo.totalSpace
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatByte")(
                                            item.driveInfo.usedSpace
                                          )
                                        ) +
                                          "/" +
                                          _vm._s(
                                            _vm._f("formatByte")(
                                              item.driveInfo.totalSpace
                                            )
                                          )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !item.driveInfo.totalSpace &&
                                !item.isRotate &&
                                item.haveLoad
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.failed"))
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon-util cloud-refresh home-refresh-position",
                              class: [!item.isRotate ? "rotate" : "rotate1"],
                              on: {
                                click: function($event) {
                                  return _vm.getDriveInfo(item)
                                }
                              }
                            })
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.drivesDown.length
                    ? _c("div", { staticClass: "hr" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "home-clouds-down",
                      style: {
                        height: Math.ceil(_vm.drivesDown.length / 7) * 81 + "px"
                      }
                    },
                    _vm._l(_vm.drivesDown, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "home-cloud",
                          class:
                            _vm.downIndexCurrent == index ? "cloud-click " : "",
                          on: {
                            dblclick: function($event) {
                              return _vm.toCloudCatalog(item)
                            },
                            click: function($event) {
                              ;(_vm.downIndexCurrent = index),
                                (_vm.indexCurrent = -1)
                            },
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.editDriveMenushow(
                                $event,
                                index,
                                item,
                                "down"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "add-cloud-item",
                              attrs: { title: _vm.showInfo(item) }
                            },
                            [
                              _c("div", {
                                staticClass: "icon  cloud-position",
                                class: item.appName + "-small"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "drive-down" }, [
                                _c(
                                  "div",
                                  {
                                    ref: "driveDownName",
                                    refInFor: true,
                                    staticClass: "drive-down-name"
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "inputDownName",
                                    refInFor: true,
                                    staticClass: "home-down-outclass"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.inputValue,
                                          expression: "item.inputValue"
                                        }
                                      ],
                                      staticClass: "home-task-edit",
                                      domProps: { value: item.inputValue },
                                      on: {
                                        focus: function($event) {
                                          _vm.isflage = true
                                        },
                                        blur: function($event) {
                                          return _vm.submitDriveName(
                                            item,
                                            index
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "inputValue",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "home-edit-icon" },
                                      [
                                        _c("i", {
                                          staticClass: "icon-util name-sure",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.submitDriveName(
                                                item,
                                                index
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "icon-util name-cancel ",
                                          on: {
                                            mousedown: function($event) {
                                              $event.stopPropagation()
                                              return _vm.cancelEditDriveName(
                                                item,
                                                index
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editHomeShow,
                          expression: "editHomeShow"
                        },
                        {
                          name: "clickoutside",
                          rawName: "v-clickoutside",
                          value: _vm.editHomeMenuClose,
                          expression: "editHomeMenuClose"
                        }
                      ],
                      staticClass: "edit-drives-menus",
                      staticStyle: { position: "absolute" },
                      attrs: { id: "editHomeMenus" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "edit-drive-menu",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.editDriveName()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "new-position rename edit-drive-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.rename")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "edit-drive-menu",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.rewriteDrive()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util edit-small edit-drive-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.leftBanner.edit")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "edit-drive-menu",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.removeDialogShow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "new-position delete edit-drive-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.leftBanner.remove")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "edit-drive-menu",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.propertiesDialogShow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "new-position properties edit-drive-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.properties")))
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "selectInfo-footer" }, [
              _c("div", { staticClass: "select-Info" }, [
                _vm._v(
                  "Clouds:" +
                    _vm._s(
                      _vm.drivesUp.length +
                        _vm.drivesDown.length -
                        _vm.ftpArr.length -
                        _vm.webDav.length
                    )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "select-Info" }, [
                _vm._v("FTP:" + _vm._s(_vm.ftpArr.length))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "select-Info" }, [
                _vm._v("WebDAV:" + _vm._s(_vm.webDav.length))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.snapTaskIconShow,
                      expression: "snapTaskIconShow"
                    }
                  ],
                  staticClass: "icon scaling-open scaling-open-position",
                  on: {
                    click: function($event) {
                      return _vm.snapTasksOpen()
                    }
                  }
                },
                [
                  _c("snapTaskDialog", {
                    ref: "snapTaskDialog",
                    on: {
                      cancel: function($event) {
                        return _vm.cancelUpload($event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("propertiesDialog", {
            ref: "propertiesDialog",
            attrs: {
              cloudName: _vm.cloudName,
              cloudId: _vm.cloudId,
              cloud: _vm.cloud
            }
          }),
          _vm._v(" "),
          _c("removeDialog", {
            ref: "removeDialog",
            attrs: { cloudId: _vm.cloudId }
          }),
          _vm._v(" "),
          _c("editCloudDialog", {
            ref: "editCloudDialog",
            attrs: { cloudType: _vm.cloudName, cloudId: _vm.cloudId }
          }),
          _vm._v(" "),
          _c("editFtpDialog", { ref: "editFtpDialog" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.clouds.length,
              expression: "!clouds.length"
            }
          ],
          staticClass: "welcome-all"
        },
        [
          _c("div", { staticClass: "welcome-to" }, [
            _c("div", { staticClass: "welcome-img" }),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-text" }, [
              _c("div", { staticClass: "welcome-position" }, [
                _c("div", { staticClass: "welcome-title" }, [
                  _vm._v(_vm._s(_vm.$t("language.addCloud.welcomeTo")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "welcome-font" }, [
                  _vm._v(_vm._s(_vm.$t("language.addCloud.welcomeFont")))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "welcome-botton ",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toAddCloudPage()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon addCloudIcon add-icon-position"
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("language.common.addCloud")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "welcome-bottom" })
        ]
      ),
      _vm._v(" "),
      _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
      _vm._v(" "),
      _c("retryFailedDialog", { ref: "retryFailedDialog" }),
      _vm._v(" "),
      _c("cancelAllDialog", { ref: "cancelAllDialog" }),
      _vm._v(" "),
      _c("editNasDialog", { ref: "editNasDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a00ba9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a00ba9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/home.vue
// module id = null
// module chunks = 